import React from "react";
import { Flex, Text } from "../../assets/ui";
import { EmailIcon, PhoneIcon } from "../../assets/icons";
import styled from "styled-components";
import Theme from "../../assets/ui/theme";

const Block = styled(Flex)`
  flex-direction: column;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  
  & p {
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #233247;
    margin-bottom: 20px;
  }
  
  & h3 {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #233247;
    margin-bottom: 5px;
  }
  
  & img {
    width: 100%;
    height: auto;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 50%;
    max-width: 340px;
  }
`;

const StyledSectionWrapper = styled(Flex)`
  flex-direction: column;
  padding: 56px 24px;

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    padding: 75px 80px 120px;
    max-width: 1280px;
    margin: 0 auto;
  }
`;

const MainStaff = () => {
  return (
    <StyledSectionWrapper>
      <Text
        fontSize={["24px", null, "32px"]}
        LineHeight={["30px", null, "40px"]}
        color={Theme.colors.darkBlue}
        fontWeight="bold"
        marginBottom={["40px", null, "56px"]}
      >
        Team Leaders
      </Text>

      <Flex flexDirection={["column", "row"]}>
        <Block marginBottom={["16px", "0"]} marginRight={[0, "32px"]}>
          <img src="./images/justin.png" alt="" />
          <Flex flexDirection={["column"]} padding={["18px 24px"]}>
            <h3>Justin Cohen</h3>
            <p>Head of product</p>
            <Flex alignItems="center" marginBottom="6px">
              <EmailIcon />
              <Text
                marginLeft="14px"
                fontSize={["14px"]}
                LineHeight={["20px"]}
                color={Theme.colors.silverWhite}
              >
                sjc@exsportia.com
              </Text>
            </Flex>
            <Flex>
              <PhoneIcon />
              <Text
                marginLeft="14px"
                fontSize={["14px"]}
                LineHeight={["20px"]}
                color={Theme.colors.silverWhite}
              >
                +972532246429
              </Text>
            </Flex>
          </Flex>
        </Block>

        <Block>
          <img src="./images/david.png" alt="" />
          <Flex flexDirection={["column"]} padding={["18px 24px"]}>
            <h3>David Freeman</h3>
            <p>Head of Sales</p>
            <Flex alignItems="center" marginBottom="6px">
              <EmailIcon />
              <Text
                marginLeft="14px"
                fontSize={["14px"]}
                LineHeight={["20px"]}
                color={Theme.colors.silverWhite}
              >
                david.freeman@exsportia.com
              </Text>
            </Flex>
            <Flex alignItems="center">
              <PhoneIcon />
              <Text
                marginLeft="14px"
                fontSize={["14px"]}
                LineHeight={["20px"]}
                color={Theme.colors.silverWhite}
              >
                +972532246429
              </Text>
            </Flex>
          </Flex>
        </Block>
      </Flex>
    </StyledSectionWrapper>
  );
};

export default MainStaff;
